<mad-readonly-form-field
  [id]="'lastChangedBy'"
  [label]="'Last changed by'"
  suffix="help"
  (suffixClickedEmitter)="suffixClicked()"
  [value]="'Jennifer Doe'"
/>
<mad-readonly-form-field
  [value]="'2019-08-09' | date: 'd. MMMM y'"
  [label]="'Last changed at'"
  prefix="info"
  (prefixClickedEmitter)="prefixClicked()"
/>
<mad-readonly-form-field [label]="'Approved by'"></mad-readonly-form-field>
<mad-readonly-form-field [value]="123456" [label]="'Long number, not formatted (default)'"></mad-readonly-form-field>
<mad-readonly-form-field [value]="123456" [label]="'Long number, formatted as number'" [formatNumber]="true"></mad-readonly-form-field>
<mad-readonly-form-field [value]="zeroValue" [label]="'Zero value'"></mad-readonly-form-field>
<mad-readonly-form-field [label]="'I am a link'" [useProjectedContent]="true"
  ><a href="www.google.com" target="_blank">TADA</a></mad-readonly-form-field
>
<mad-readonly-form-field
  [value]="12000000000"
  [label]="'Number with percentage suffix'"
  unit="%"
  unitPosition="right"
></mad-readonly-form-field>
<mad-readonly-form-field
  [label]="'Just some other high number'"
  [value]="999999999.99"
  [unit]="'€'"
  [decimalPlaces]="2"
  [autofillDecimals]="true"
  unitPosition="right"
  [formatNumber]="true"
></mad-readonly-form-field>
<mad-readonly-form-field [value]="154.48" [label]="'Number with Euro prefix'" unit="€" unitPosition="left"></mad-readonly-form-field>
<mad-readonly-form-field [value]="nullValue" [label]="'Null value'"></mad-readonly-form-field>
<mad-readonly-form-field [value]="undefinedValue" [label]="'Undefined value'"></mad-readonly-form-field>
<mad-readonly-form-field [value]="" label="First name"></mad-readonly-form-field>
<mad-readonly-form-field [value]="demoText" [multiline]="true" label="Text with multiple lines"></mad-readonly-form-field>
<mad-readonly-form-field
  [value]="nullValue"
  [multiline]="true"
  [rows]="4"
  [shrinkIfEmpty]="true"
  label="This text is defined to have 4 lines, but is shrank to one line, because it's empty"
></mad-readonly-form-field>
